import { Box } from "@material-ui/core";
import React from "react";
import LinearProgress from '@material-ui/core/LinearProgress';

export default function LinearProgressWithLabel(props) {
    return (
        <Box display="flex" alignItems="center">
            <Box width="100%" mr={1}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box minWidth={35}>
                {`${Math.round(
                    props.value,
                )}%`}
            </Box>
        </Box>
    );
}